
import request from '@/libs/request'
import {getStorage} from "@/libs/Storage";
import {encryptAES} from "@/utils";


/**
 * 获取列表
 * @returns {*}
 */
export function promotionList(params){
    return request({
        url: `/api/promotion/index`,
        method: 'get',
        params
    })
}


/**
 * 点击按钮
 * @returns {*}
 */
export function clickButton(data){
    return request({
        url: `/api/pageviews/save`,
        method: 'post',
        data,
    })
}













